import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../../service-call-utils.service';
import { constants } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class FilterFourService {
  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }


  /**
   * Description: Método que llama el servicio web de obtener todas las tecnologiaS
   * Autor: Luis Hernandez
   * @return Tecnologias
   */
  get_technology_coverage_list() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_TECHNOLOGY_C0VERAGE_LIST,{});
  }

  
  /**
   * Description: Método que llama el servicio web de obtener todas las carreteras segun la tecnologia
   * Autor: Luis Hernandez
   * @param technology tecnologia a consultar
   * @return Carreteras
   */
  get_road_coverage(technology) {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_ROAD_COVERAGE, { "technology": technology });
  }

  /**
   * Description: Método que llama el servicio web para obtener todas la regiones de una carretera en especifico
   * Autor: Luis Hernandez
   * @param technology tecnologia a consultar
   * @param road carretera a consultar
   * @return Regiones
   */
  get_coverage_road_technology(technology, road){
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_COVERAGE_ROAD_TECHNOLOGY, { "technology": technology, "road":road });
  }

  /**
   * Description: Method that calls the web service that returns whether or not there is a recurrence combo with the number
   * Autor: Luis Hernandez
   * @param phone número a consultar
   * @return boolean
   */
  // getFindSubscription(line) {
  //   return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_SUBSCRIPTION, { "contractIdentifier": line });
  // }



  
}
